import React, {useEffect, useRef} from 'react';
import {Button, DatePicker, Descriptions, Form, Input, InputNumber, Modal, Select, Spin, Table} from 'antd';
import {updatecwsrdj, getcwsrdj} from "../../lib/api_cw_srdj";
import {getDetail} from "../../lib/api_cw_zcfkd";
import moment from "moment";
import styles from './zcfkd_modal.module.css';

/**
 * 付款单弹窗
 * @param onCancel
 * @param onOk
 * @returns {JSX.Element}
 * @constructor
 */
const ZcfkdEditModal = ({id, onCancel, onOk}) => {
    const [loading, setLoading] = React.useState(false);
    const [data, setData] = React.useState({});
    const printContentRef = useRef(null);

    const fetchData = () => {
        setLoading(true)
        getDetail(id)
            .then(res => {
                if (res.code === 0) {
                    setData(res.data);
                }
            })
            .finally(() => {
                setLoading(false);
            });
    }

    useEffect(fetchData, [id]);

    const handleOk = () => {
        onOk && onOk();
    }
    const handleCancel = () => {
        onCancel && onCancel();
    }

    const handlePrint = () => {
        if (printContentRef.current) {
            // 创建一个包含原始类名的打印内容
            const printWindow = window.open('', '_blank');
            printWindow.document.write(`
      <html>
        <head>
          <title>打印内容</title>
          <style>
            body {
              font-family: Arial, sans-serif;
              padding: 20px;
              font-size: 16px; /* 所有字号加大2号 */
            }
            .print-container {
              max-width: 800px;
              margin: 0 auto;
            }
            .print-title {
              text-align: center;
              font-size: 24px;
              font-weight: bold;
              margin-bottom: 20px;
            }
            .print-info {
              margin: 15px 0;
              padding: 10px;
              background-color: #f9f9f9;
              border: 1px solid #ddd;
              border-radius: 3px;
            }
            .print-info div {
              margin: 5px 0;
            }
            .print-amount {
              font-size: 20px;
              font-weight: bold;
              color: #e74c3c;
            }
            .account-info {
              margin: 15px 0;
              padding: 10px;
              border: 1px solid #ddd;
              border-radius: 3px;
              background-color: #f9f9f9;
            }
            .account-info-item {
              margin: 5px 0;
            }
            .print-table {
              width: 100%;
              border-collapse: collapse;
              margin: 20px 0;
              background-color: #fff;
            }
            .print-table th,
            .print-table td {
              border: 1px solid #000;
              padding: 8px;
              text-align: center;
            }
            .print-table th {
              background-color: #f5f5f5;
              font-weight: bold;
            }
            .print-table tbody tr:nth-child(even) {
              background-color: #f9f9f9;
            }
            .signature-section {
              display: flex;
              justify-content: space-between;
              margin-top: 40px;
              font-size: 18px;
            }
            .signature-line {
              border-bottom: 1px solid #000;
              width: 200px;
              margin-left: 10px;
              display: inline-block;
              height: 20px;
              vertical-align: middle;
            }
            .manager-signature-line {
              border-bottom: 1px solid #000;
              width: 300px;
              margin-left: 10px;
              display: inline-block;
              height: 20px;
              vertical-align: middle;
            }
          </style>
        </head>
        <body>
          <div class="print-container">
            <div class="print-title">合并付款单${data.id ? `<div style="font-size: 18px; display: inline-block;">（${data.id}）</div>` : ''}</div>
            ${data.sub_title ? `<div style="text-align: center; font-size: 18px; margin-bottom: 20px;">${data.sub_title}</div>` : ''}
            <div class="print-info">
              <div>创建日期: ${data.cjsj ? moment(data.cjsj).format('YYYY-MM-DD') : ''}</div>
              <div>付款金额: <span class="print-amount">${data.hjje || ''}</span></div>
              <div>笔数: ${data.bishu || ''}</div>
            </div>
            <div class="account-info">
              <div class="account-info-item">收款账户信息</div>
              <div class="account-info-item">户名: ${data.huhao || ''}</div>
              <div class="account-info-item">账号: ${data.zhanghao || ''}</div>
              <div class="account-info-item">开户行: ${data.kaihuhang || ''}</div>
            </div>
            <table class="print-table">
              <thead>
                <tr>
                  <th>审批编号</th>
                  <th style="width: 150px;">来源</th>
                  <th style="width: 120px;">支付方式</th>
                  <th>金额</th>
                  <th>事由</th>
                </tr>
              </thead>
              <tbody>
                ${data.zcdjs && data.zcdjs.map(item => `
                <tr>
                  <td>${item.sp_no || ''}</td>
                  <td>${item.ly || ''}</td>
                  <td>${item.zcfs || ''}</td>
                  <td>${item.je || ''}</td>
                  <td>${item.bz || ''}</td>
                </tr>
                `).join('')}
              </tbody>
            </table>
            <div class="signature-section">
              <div>
                制单人: <span class="signature-line"></span>
              </div>
              <div>
                总经理: <span class="manager-signature-line"></span>
              </div>
            </div>
          </div>
        </body>
      </html>
    `);
            printWindow.document.close();
            printWindow.focus();
            // 延迟执行打印，确保内容已加载
            setTimeout(() => {
                printWindow.print();
                printWindow.close();
            }, 500);
        }
    }

    return (
        <Modal
            title="付款单详情"
            open={true}
            onCancel={handleCancel}
            onOk={handleOk}
            confirmLoading={loading}
            width={1000}
            footer={false}
            style={{top: 20}}
        >
            {/*打印按钮*/}
            <Button type="primary" onClick={handlePrint}>打印</Button>
            <Spin spinning={loading}>
                <div ref={printContentRef}>
                    <div className={styles['print-title']}>
                      合并付款单
                      {data.id && (
                        <div style={{ fontSize: '18px', display: 'inline-block' }}>（{data.id}）</div>
                      )}
                    </div>
                    {data.sub_title && (
                        <div style={{ textAlign: 'center', fontSize: '18px', marginBottom: '20px' }}>
                            {data.sub_title}
                        </div>
                    )}
                    <div className={styles['print-info']}>
                        <div>创建日期: {data.cjsj ? moment(data.cjsj).format('YYYY-MM-DD') : ''}</div>
                        <div>付款金额: <span className={styles['print-amount']}>{data.hjje || ''}</span></div>
                        <div>笔数: {data.bishu || ''}</div>
                    </div>
                    <div className={styles['account-info']}>
                        <div className={styles['account-info-item']}>收款账户信息</div>
                        <div className={styles['account-info-item']}>户名: {data.huhao || ''}</div>
                        <div className={styles['account-info-item']}>账号: {data.zhanghao || ''}</div>
                        <div className={styles['account-info-item']}>开户行: {data.kaihuhang || ''}</div>
                    </div>
                    <table className={styles['print-table']}>
                        <thead>
                            <tr>
                                <th>审批编号</th>
                                <th style={{width: '150px'}}>来源</th>
                                <th style={{width: '120px'}}>支付方式</th>
                                <th>金额</th>
                                <th>事由</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.zcdjs && data.zcdjs.map(item => (
                                <tr key={item.id}>
                                    <td>{item.sp_no || ''}</td>
                                    <td>{item.ly || ''}</td>
                                    <td>{item.zcfs || ''}</td>
                                    <td>{item.je || ''}</td>
                                    <td>{item.bz || ''}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    <div className={styles['signature-section']}>
                        <div>
                            制单人: <span className={styles['signature-line']}></span>
                        </div>
                        <div>
                            总经理: <span className={styles['manager-signature-line']}></span>
                        </div>
                    </div>
                </div>
            </Spin>
        </Modal>
    )
}

export default ZcfkdEditModal;